import * as React from 'react';
import { Column, SortDirection } from '../DataTable';
import { ColumnHeader } from './ColumnHeader';

export interface HeaderProps {
    /**
     * The table columns
     */
    columns: Column[];
    /**
     * Function to handle a change in sorting
     */
    onSort?: (sortColumn: Column, sortDirection: SortDirection) => void;
    /**
     * The column we're sorting on
     */
    sortColumn?: Column;
    /**
     * The direction we're sorting
     */
    sortDirection: SortDirection;
    /**
     * Function to invoke when the fill link is clicked to show the popup
     */
    showFillPopup: (
        column: Column,
        event: React.MouseEvent<HTMLAnchorElement>
    ) => void;
}

/**
 * Component for the table header
 * @param props Component props
 */
export function Header(props: HeaderProps) {
    return (
        <thead>
            <tr>
                {props.columns.map(column => (
                    <ColumnHeader
                        key={column.key}
                        column={column}
                        onSort={props.onSort}
                        sortColumn={props.sortColumn}
                        sortDirection={props.sortDirection}
                        showFillPopup={event =>
                            props.showFillPopup(column, event)
                        }
                    />
                ))}
            </tr>
        </thead>
    );
}
